<template>
	<el-select remote-show-suffix clearable filterable :style="{'width': `${width}`}" :disabled="disabled" :size="size"
		v-model="TypeId" :loading="loading" @focus="SelectFocus" :placeholder="placeholder"
		@change="TypeChange" @clear="TypeClear">
		<el-option v-for="v in LocationTypeList" :key="v[ValueKey]" :label="v[LabelKey]" :value="v[ValueKey]" />
	</el-select>
</template>

<script lang="ts" setup>
	import { ref, getCurrentInstance, defineEmits, defineProps, withDefaults, onMounted, watch } from 'vue';

	interface main {
		id ?: string | number,
		size ?: string,
		placeholder ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
	};

	const props = withDefaults(defineProps<main>(), {
		id: "",
		size: "default",
		placeholder: "请选择类型",
		ValueKey: "value",
		LabelKey: "label",
		width: "100%",
		disabled: false,
		IsAuto: false,
	});

	const { proxy } = getCurrentInstance() as any;
	const emits = defineEmits(["update:id", "change", "clear"]);
	const TypeId = ref<any>("");
	const LocationTypeList = ref<any>([]);
	const loading = ref(false);

	watch(() => props.id, (n : any) => {
		TypeId.value = n;
	});

	onMounted(() => {
		TypeId.value = props.id;
		if (props.IsAuto) {
			if (proxy.$store.state.IsRefreshLocationType) {
				GetData();
			} else {
				if (proxy.$store.state.LocationTypeList.length > 0) {
					LocationTypeList.value = proxy.$store.state.LocationTypeList;
				} else {
					GetData();
				}
			}
		}
	});

	const TypeChange = (data : any) => {
		emits("update:id", data);
		emits("change", data);
	};
	const TypeClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (proxy.$store.state.IsRefreshLocationType) {
			GetData();
		} else {
			if (proxy.$store.state.LocationTypeList.length > 0) {
				LocationTypeList.value = proxy.$store.state.LocationTypeList;
			} else {
				GetData();
			}
		}
	};
	const GetData = () => {
		proxy.$api.tokenRequest({
			url: '/admin/type',
			data: {
				type: 2,
				is_page: 0,
			},
			success: (res : any) => {
				loading.value = false;
				LocationTypeList.value = res.data;
				proxy.$store.commit("GetAllList", {
					type: 13,
					data: res.data,
				});
			},
		});
	};
</script>

<style>
</style>